export default __webpack_public_path__ + "4e61a8fbdc7257f5a08e7bde75ca2aa3.svg";